import { apiClient } from "@/shared/services/api";
import type { ApiResponse } from "@/features/auth/services/authApi";

export interface InputType {
  id: string;
  code: string;
  name: string;
  description: string;
  isActive: boolean;
  createdAt: string;
}

export interface CreateInputTypeRequest {
  code: string;
  name: string;
  description: string;
}

export interface UpdateInputTypeRequest {
  id: string;
  name: string;
  description: string;
  isActive: boolean;
}

export const inputTypesApi = {
  getAllInputTypes: async (): Promise<InputType[]> => {
    const { data } = await apiClient.get<ApiResponse<InputType[]>>(
      "/InputTypes"
    );
    return data.data;
  },

  getActiveInputTypes: async (): Promise<InputType[]> => {
    const { data } = await apiClient.get<ApiResponse<InputType[]>>(
      "/InputTypes/active"
    );
    return data.data;
  },

  getInputTypeById: async (id: string): Promise<InputType> => {
    const { data } = await apiClient.get<ApiResponse<InputType>>(
      `/InputTypes/${id}`
    );
    return data.data;
  },

  getInputTypeByCode: async (code: string): Promise<InputType> => {
    const { data } = await apiClient.get<ApiResponse<InputType>>(
      `/InputTypes/by-code/${code}`
    );
    return data.data;
  },

  createInputType: async (
    payload: CreateInputTypeRequest
  ): Promise<InputType> => {
    const { data } = await apiClient.post<ApiResponse<InputType>>(
      "/InputTypes",
      payload
    );
    return data.data;
  },

  updateInputType: async (
    payload: UpdateInputTypeRequest
  ): Promise<InputType> => {
    const { data } = await apiClient.put<ApiResponse<InputType>>(
      `/InputTypes/${payload.id}`,
      payload
    );
    return data.data;
  },

  deactivateInputType: async (id: string): Promise<void> => {
    await apiClient.delete(`/InputTypes/${id}`);
  },
};